export default ["dev","404.html","about.html","brand.html","catalog-category.html","catalog.html","contacts.html","index.html","leasing.html","news-one.html","news.html","product-page.html","search-not-result.html","search.html","service.html","vacancy.html"]


// WEBPACK FOOTER //
// app/scripts/files.js